<template>
  <div>
    <md-dialog :md-click-outside-to-close="false" v-if="feedback" :md-active.sync="showDialog" @md-closed="closeDialog">
      <md-dialog-title v-if="mode === 'update'">
        <form novalidate @submit.prevent="validateFeedback">
          <div class="grid-x grid-padding-x">
            <div class="cell large-5 medium-5">
              <i class="fi-pencil"></i>&nbsp;&nbsp;&nbsp;Feedback bearbeiten
            </div>
            <div class="cell large-2 medium-1" style="margin-top: -5px;">
              <SessionTime></SessionTime>
            </div>
            <div class="cell large-5 medium-6 text-center">
              <button class="button success" type="submit" :disabled="sending">
                <i class="fi-save"></i>&nbsp;&nbsp;&nbsp;Änderungen speichern
              </button>
              <button class="button alert" style="margin-left: 1rem;" @click="closeDialog" type="button"
                      :disabled="sending">
                <i class="fi-x"></i>&nbsp;&nbsp;&nbsp;Abbrechen
              </button>
            </div>
          </div>
        </form>
      </md-dialog-title>

      <md-dialog-content>
        <md-progress-bar md-mode="indeterminate" v-if="sending"/>
        <br>
        <FeedbackForm ref="feedbackForm" :feedback="feedback" :sending="sending" :mode="mode"/>
      </md-dialog-content>

      <button class="close-button" type="button" @click="closeDialog">
        <span aria-hidden="true">&times;</span>
      </button>
    </md-dialog>
  </div>
</template>

<script>

  import FeedbackForm from '../forms/FeedbackForm';
  import SessionTime from '../animations/SessionTime';

  import FeedbackService from '../../services/FeedbackService';
  import HttpErrorHandler from '../../services/HttpErrorHandler';

  import {validationMixin} from 'vuelidate'

  export default {
    name: 'EditFeedbackDialog',
    mixins: [validationMixin],

    components: {
      FeedbackForm,
      SessionTime,
    },

    props: {
      feedback: {
        required: true
      },
        showDialog: {
        required: true
      },
      mode: {
        required: true
      },
    },

    created() {
    },

    data: () => ({
      success: true,
      sending: false,
    }),

    methods: {
      updateFeedback() {
        this.sending = true;
        this.success = false;
        FeedbackService.updateFeedback(this.feedback)
          .then(response => {
            this.form = response.data;
            this.success = true;
            this.sending = false;
            this.$emit("updateFeedbackSuccess", this.feedback);
          })
          .catch(e => {
            HttpErrorHandler.handleError(e, this, 'Fehler beim Speichern von Feedback ' + this.feedback.title);
            this.sending = false;
          })
      },

      addFeedback() {
        this.sending = true;
        this.success = false;
        FeedbackService.createFeedback(this.feedback)
          .then(response => {
            this.form = response.data;
            this.success = true;
            this.sending = false;
            this.$emit("updateFeedbackSuccess");
          })
          .catch(e => {
            HttpErrorHandler.handleError(e, this, 'Fehler beim Hinzufügen von Feedback ' + this.feedback.title);
            this.sending = false;
          })
      },

      validateFeedback() {
        this.$refs.feedbackForm.validateFeedback();

        if (!this.$refs.feedbackForm.invalid) {

          if (this.mode === 'update') {
            this.updateFeedback();
          }
          if (this.mode === 'add') {
            this.addFeedback();
          }
        }
      },

      closeDialog() {
        this.$emit("closeEditFeedbackDialog");
      },
    },

    computed: {

      isAuthenticated() {
        return this.$store.getters.authenticated
      },

      isAdmin() {
        return this.$store.getters.admin
      },

      isSage() {
        return this.$store.getters.sage
      },

      organization() {
        return this.$store.getters.organization;
      },
    },
  };
</script>

<style scoped>
  .md-dialog /deep/.md-dialog-container {
    min-width: 90%;
  }

  .md-dialog-content {
    max-width: 100%;
  }
</style>